<template>
  <div class="ma-2">
    <v-row dense>
      <v-col cols="12" sm="6">
        <span class="caption font-weight-bold">E-mail</span>
        <div>
          {{ solicitacao.transportadora.pessoa.email }}
        </div>
      </v-col>
      <v-col cols="12" sm="6">
        <span class="caption font-weight-bold">Telefone</span>
        <div>
          {{ solicitacao.transportadora.pessoa.telefone }}
        </div>
      </v-col>
    </v-row>
    <v-row dense>
      <v-col cols="12" sm="6">
        <span class="caption font-weight-bold">Nº da solicitação:</span>
        <div>
          {{ solicitacao.id }}
        </div>
      </v-col>
      <v-col cols="12" sm="6">
        <span class="caption font-weight-bold">Nº da cotação:</span>
        <div>
          {{ cotacaoId }}
        </div>
      </v-col>
    </v-row>
    <v-row dense>
      <v-col cols="12" sm="12">
        <span class="caption font-weight-bold">Link</span>
        <div>
          <a :href="url" target="_blank">{{ url }}</a>
        </div>
      </v-col>
    </v-row>
    <px-fornecedor-detalhes :id-solicitacao="solicitacao.id" tipo-cotacao="cotacoes-fretes"/>
    <v-row dense>
      <v-col cols="12">
        <v-btn class="mr-4" color="primary"
               :loading="loadingEnviarEmail"
               @click="enviarEmail">
          Enviar e-mail
        </v-btn>
        <v-btn class="mr-4" color="primary"
               :loading="loadingEnviarWhatsapp"
               @click="enviarWhatsapp">
          Enviar Whatsapp
        </v-btn>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import CotacaoService from '@/modules/cotacoes-frete/cotacao-frete-service';

export default {
  props: {
    solicitacao: Object,
    cotacaoId: [String, Number],
  },
  data() {
    return {
      loadingEnviarEmail: false,
      loadingEnviarWhatsapp: false,
    };
  },
  methods: {
    enviarEmail() {
      this.loadingEnviarEmail = true;
      CotacaoService.enviarEmail(this.cotacaoId, this.solicitacao.id)
        .then(() => {
          this.$toast('E-mail enviado com sucesso', { color: 'success' });
        })
        .finally(() => {
          this.loadingEnviarEmail = false;
        });
    },
    enviarWhatsapp() {
      this.loadingEnviarWhatsapp = true;
      CotacaoService.enviarWhatsapp(this.cotacaoId, this.solicitacao.id)
        .then(() => {
          this.$toast('Whatsapp enviado com sucesso', { color: 'success' });
        })
        .finally(() => {
          this.loadingEnviarWhatsapp = false;
        });
    },
  },
  computed: {
    url() {
      return `${process.env.VUE_APP_TRANSPORTADOR_URL}/cotacoes/${btoa(this.solicitacao.id)}?k=${this.solicitacao.key}`;
    },
  },
};
</script>
